import { parseStyleDefaults, type StyleDefaults } from "../shared/feature-style.ts";

const STYLE_DEFAULTS_KEY = "mapus.style.defaults";

export function readStyleDefaults(): StyleDefaults {
  try {
    const raw = localStorage.getItem(STYLE_DEFAULTS_KEY);
    if (!raw) return parseStyleDefaults(null);
    return parseStyleDefaults(JSON.parse(raw));
  } catch {
    return parseStyleDefaults(null);
  }
}

export function writeStyleDefaults(defaults: StyleDefaults): void {
  const next = parseStyleDefaults(defaults);
  try {
    localStorage.setItem(STYLE_DEFAULTS_KEY, JSON.stringify(next));
  } catch {
    /* private mode */
  }
}
